import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { handleError, AuthError } from "@/lib/errorHandling";
import { clearGuestStatus } from "@/utils/guestDetection";

export function useSignOut() {
  const navigate = useNavigate();

  const signOut = async () => {
    try {
      console.log("Signing out user");
      
      // Set a flag to prevent auth state restoration
      localStorage.setItem('authSignOutInProgress', 'true');
      // Also set a global flag
      (window as any).__authSignOutInProgress = true;
      
      // Clear all auth-related localStorage items
      const SESSION_STORAGE_KEYS = {
        SESSION: 'deepFocus_session',
        USER_ID: 'deepFocus_userId',
        SESSION_ID: 'deepFocus_sessionId',
        LAST_ACTIVITY: 'deepFocus_lastActivity',
        REFRESH_ATTEMPTS: 'deepFocus_refreshAttempts',
        AUTH_STATE: 'deepFocus_authState'
      };
      
      // Clear all session storage keys
      Object.values(SESSION_STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
      
      // Clear the auth state immediately
      localStorage.removeItem('deepFocus_authState');
      
      // Clear any other auth-related localStorage items
      localStorage.removeItem('skipAuthChecks');
      localStorage.removeItem('disableAuthRedirect');
      localStorage.removeItem('navigatingToSession');
      localStorage.removeItem('lastNavigation');
      localStorage.removeItem('authInitialized');
      localStorage.removeItem('authStateRestored');
      localStorage.removeItem('testUser');
      // Clear timer state to prevent ghost sessions
      localStorage.removeItem('deepfocus_timer_state');
      
      // Clear guest status from sessionStorage to prevent redirect to /join after sign-in
      clearGuestStatus();
      
      // Sign out from Supabase
      const { error } = await supabase.auth.signOut();
      if (error) {
        throw new AuthError("Failed to sign out", "SIGNOUT_ERROR");
      }
      
      console.log("User signed out successfully");
      
      // Force a page reload to ensure clean state
      window.location.href = '/';
      
    } catch (error) {
      console.error("Error signing out:", error);
      handleError(error, "signing out");
      
      // Even if there's an error, try to clear local state and redirect
      window.location.href = '/';
    }
  };

  return { signOut };
}

export default useSignOut;